export const SIGNUP = 'SIGNUP'
export const LOGIN = 'LOGIN'
export const UPDATE = 'UPDATE'
export const LOGOUT = 'LOGOUT'
